import * as yup from 'yup';

// 0-9, (), +, or -
const phoneRexex = /[0-9+()-]*/;
// 00-00-0000
const dateRegex = /^([0-9][0-9])-([0-9][0-9])-\d{4}$/;
// 1234AB
const zipcodeRegex = /^\d{4}[A-Z]{2}$/;

export const validationSchema = yup.object().shape({
    birthdate: yup
        .string()
        .matches(dateRegex, 'Geen geldige datum')
        .required('Vul een datum in'),
    relocationDate: yup
        .string()
        .matches(dateRegex, 'Geen geldige datum')
        .required('Vul een datum in'),
    salutation: yup.string(),
    firstName: yup.string().required('Vul een voornaam in'),
    lastNamePrefix: yup.string(),
    lastName: yup.string().required('Vul een achternaam in'),
    customerEmail: yup
        .string()
        .email('Geen geldig e-mailadres')
        .required('Vul een e-mailadres in'),
    phoneNumber: yup
        .string()
        .matches(phoneRexex, 'Geen geldig telefoonnummer')
        .required('Vul een telefoonnummer in'),
    street: yup.string().required('Vul de straatnaam in'),
    newStreet: yup.string().required('Vul de straatnaam in'),
    houseNumber: yup.string().required('Vul het huisnummer in'),
    newHouseNumber: yup.string().required('Vul het huisnummer in'),
    houseNumberAddition: yup.string(),
    newHouseNumberAddition: yup.string(),
    zipcode: yup
        .string()
        .matches(zipcodeRegex, 'Geen geldige postcode')
        .required('Vul de postcode in'),
    newZipcode: yup
        .string()
        .matches(zipcodeRegex, 'Geen geldige postcode')
        .required('Vul de postcode in'),
    city: yup.string().required('Vul de plaatsnaam in'),
    newCity: yup.string().required('Vul de plaatsnaam in'),
    store: yup.string().required('Kies een winkel'),
    storeTwo: yup.string(),
});
